module.exports = __webpack_public_path__ + "img/xmsb9.134a8ba7.png";